import { React, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import BaseHome from "../Home/BaseHome";
import ContestDetailTab from "./contestDetailTabs/contestDetailTab";
import ContestPlayerTab from "./contestDetailTabs/contestPlayersTab";
import ContestRulesTab from "./contestDetailTabs/contestRules";
import { useParams } from "react-router";
import { useNavigate } from 'react-router-dom';
import WinningBreakup from "../Popup/WinningPopup";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box className="tab-content">{children}</Box>}
    </div>
  );
};

const ContestDetails = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0); // Control the selected tab state
  const [contestDetails,setContestDetailsData] = useState(null);
  const { id } = useParams();
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [isQualification, setQualification] = useState(false);
  
  const [isPricePointPoolModel, setPricePointPool] = useState(false);
  const [winningbrarkupContest, setWinningBrarkupContest] = useState(null);
  const [detailsWinning, setDetailsWinning] = useState(null);

  const handleQualificationClick = () => {
    setQualification(true);
  };
  const toggleInputVisibility = () => {
    setIsInputVisible(!isInputVisible);
  };
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };


  return (
    <>
      <BaseHome title="contest details" onBackClick={() => navigate(-1)}>
        <div className="commontabs custome-tabing-section">
          <div className="commontabs-innerwrap">
            <Tabs value={selectedTab} onChange={handleChange} className="tabs-container  custome-tabing-wrap">
              <Tab label="details" className="tab custome-tab" style={{ textTransform: 'lowercase' }} />
              <Tab label="players" className="tab custome-tab" style={{ textTransform: 'lowercase' }} />
              <Tab label="rules" className="tab custome-tab" style={{ textTransform: 'lowercase' }} />
            </Tabs>
          </div>

          <TabPanel className="tab-panel contest-tab-panel" value={selectedTab} index={0}>
            <ContestDetailTab contestId={id} setContestDetailsData ={setContestDetailsData} setPricePointPool={setPricePointPool} setWinningBrarkupContest={setWinningBrarkupContest} setDetailsWinning={setDetailsWinning} />
          </TabPanel>
          <TabPanel className="tab-panel contest-tab-panel" value={selectedTab} index={1}>
            <ContestPlayerTab contestId={id} contestDetails={contestDetails}/>
          </TabPanel>
          <TabPanel className="tab-panel contest-tab-panel" value={selectedTab} index={2}>
            <ContestRulesTab contestId={id} />
          </TabPanel>
        </div>

        {isPricePointPoolModel && winningbrarkupContest != null && (
          <WinningBreakup
            isOpen={isPricePointPoolModel}
            contestId={winningbrarkupContest}
            contestData={detailsWinning}
            popupType={'contest'}
            title="Winning Breakup"
            onClose={() => setPricePointPool(false)}
          />
        )}
      </BaseHome>
    </>
  );
};

export default ContestDetails;
